/*
 * @Description: '首页'所有的路由
 * @Author: 任录
 * @Date: 2019-07-22 16:47:39
 * @LastEditTime: 2019-07-25 10:11:20
 * @LastEditors: Please set LastEditors
*/

export default [
    {
        path: '/',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home',
        meta: {
            nav: '首页'
        }
    },
    {
        path: '/home',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home-2',
        meta: {
            nav: '首页'
        }
    },
    {
      path: '/plan',
      component: resolve => require(['@/views/plan'], resolve),
      name: 'Plan',
      meta: {
        nav: '留学规划'
      }
    },
  {
    path: '/plan/detail',
    component: resolve => require(['@/views/plan/detail'], resolve),
    name: 'PlanDetail',
    meta: {
      nav: '留学规划'
    }
  },
  {
    path: '/information',
    component: resolve => require(['@/views/information'], resolve),
    name: 'Information',
    meta: {
      nav: '留学资讯'
    }
  },
  {
    path: '/lecture',
    component: resolve => require(['@/views/lecture'], resolve),
    name: 'Lecture',
    meta: {
      nav: '精彩讲座'
    }
  },
  {
    path: '/exam',
    component: resolve => require(['@/views/exam'], resolve),
    name: 'Exam',
    meta: {
      nav: '出国留学考试'
    }
  },
  {
    path: '/exam/detail',
    component: resolve => require(['@/views/exam/detail'], resolve),
    name: 'Exam',
    meta: {
      nav: '出国留学考试'
    }
  },
  {
    path: '/spoken_language',
    component: resolve => require(['@/views/spokenLanguage'], resolve),
    name: 'SpokenLanguage',
    meta: {
      nav: '海外生存口语'
    }
  },
  {
    path: '/detail',
    component: resolve => require(['@/views/detail/index'], resolve),
    name: 'Detail',
    meta: {
      nav: '详情'
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/home.js